<template>
    <div></div>
</template>

<script>
export default {
    name: "TabPackage"
};
</script>

<style scoped></style>
